/**
 * Tiny module that holds the Purchases.configure() promise.
 * Separated from index.tsx to avoid circular imports in revenueCatUtils.
 */
let _purchasesReady: Promise<void> = Promise.resolve();

export const setPurchasesReady = (p: Promise<void>) => {
  _purchasesReady = p;
};

export const waitForPurchases = (): Promise<void> => _purchasesReady;
